import { render, staticRenderFns } from "./FormWasteDestination.vue?vue&type=template&id=33a0a68a&scoped=true&"
import script from "./FormWasteDestination.vue?vue&type=script&lang=js&"
export * from "./FormWasteDestination.vue?vue&type=script&lang=js&"
import style0 from "./FormWasteDestination.vue?vue&type=style&index=0&id=33a0a68a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a0a68a",
  null
  
)

export default component.exports